import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class SharedDataService {
  userIsAdmin: boolean = false;
  isProduction: boolean;

  constructor() {}
}
